<template>
<div class="data-preview" :class="{ closed : !isOpen }">
  <div class="reset">
  <h3>Data Preview 
  <v-icon v-if="isOpen" @click="isOpen = !isOpen" alt="close">mdi-archive-arrow-up-outline</v-icon>
  <v-icon v-if="!isOpen" @click="isOpen = !isOpen" alt="open">mdi-archive-arrow-down-outline</v-icon>
  </h3>
  <pre><code>{{ content }}</code></pre>
  </div>
</div>
</template>
<script>

function copyToClipboard(el) {
  var range
  if (document.selection) {
    range = document.body.createTextRange();
    range.moveToElementText(el);
    range.select().createTextRange();
    document.execCommand("copy");
  } else if (window.getSelection) {
    range = document.createRange();
    range.selectNode(el);
    window.getSelection().addRange(range);
    document.execCommand("copy");
  }
}


export default {
    data() {
        return {
            isOpen: false
        }
    },
    props: {
        rec: Object
    },
    computed: {
        content() {
            return JSON.stringify(this.rec,undefined,2)
        }
    },
    methods: {
        copy(r) {
            r.preventDefault()
			copyToClipboard(r.target)
/*
        	r.target.select()
        	r.target.setSelectionRange(0, 99999)
        	document.execCommand("copy")
*/
            return false
        },
    }
}
</script>
<style scoped>
.data-preview {
    margin-left: auto;
    margin-right: auto;
    width: 500px;
}
.data-preview div, .data-preview pre, .data-preview h3 {
    width: inherit;
}

h3 { 
    border: 1px solid black;
    margin: 0px;
}
h3 .icon {
    margin: 1px;
    float: right;
}
pre {
    border: 1px solid black;
    background-color: bisque;
    margin: 0px;
    overflow: hidden;
}

.closed pre {
    display: none;
}

.reset {
    all: initial;
    * {
        all: unset;
    }
}

</style>
